import { useEffect, useState, type FC } from "react";
import CurrencyInput from "react-currency-input-field";
import { Button, Modal, SelectPicker } from "rsuite";
import { Product, PopularProduct } from "../../../models/inventory/product";
import { getProducts } from "../../../services/inventory/ProductApi";

interface PopularProductFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: PopularProduct) => void;
  popularProduct?: PopularProduct;
}

const PopularProductForm: FC<PopularProductFormProps> = ({
  open,
  onClose,
  onSubmit,
  popularProduct,
}) => {
  const [products, setProducts] = useState<Product[]>([]);

  const [data, setData] = useState<PopularProduct>({
    id: "",
    product_id: "",
    score: 0,
  });

  const getAllProducts = async (search: string) => {
    getProducts({
      page: 1,
      size: 10,
      search,
    })
      .then((v) => v.json())
      .then((v) => setProducts(v.data.items));
  };

  useEffect(() => {
    setData(
      popularProduct || {
        id: "",
        product_id: "",
        score: 0,
      }
    );
    getAllProducts("");
  }, [popularProduct]);

  return (
    <Modal size={"lg"} open={open} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>Popular Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <div className="form-group">
            <label>Product</label>
            <div className="input">
              {popularProduct?.id ? (
                <div>{popularProduct?.product?.name}</div>
              ) : (
                <SelectPicker
                  block
                  data={products}
                  labelKey="name"
                  valueKey="id"
                  value={data.product_id}
                  onChange={(value) => {
                    setData({ ...data, product_id: value! });
                  }}
                  onSearch={(value) => {
                    if (value) {
                      getProducts({
                        page: 1,
                        size: 10,
                        search: value,
                      })
                        .then((v) => v.json())
                        .then((v) => setProducts(v.data.items));
                    }
                  }}
                />
              )}
            </div>
          </div>
          <div className="form-group">
            <label>Score</label>
            <CurrencyInput
              className="rs-input"
              value={data.score}
              groupSeparator="."
              decimalSeparator=","
              onValueChange={(value, name, values) =>
                setData({ ...data, score: values?.float ?? 0 })
              }
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-4">
          <Button appearance="primary" onClick={() => {
            onSubmit(data!)
            setData({
              id: "",
              product_id: "",
              score: 0,
            })
          }}>
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default PopularProductForm;
